export default __webpack_public_path__ + "static/media/poppins-bold.ac8d04b6.ttf";